import { render, staticRenderFns } from "./PartnersItem.vue?vue&type=template&id=e7efea6a&scoped=true&"
import script from "./PartnersItem.vue?vue&type=script&lang=js&"
export * from "./PartnersItem.vue?vue&type=script&lang=js&"
import style0 from "./PartnersItem.vue?vue&type=style&index=0&id=e7efea6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7efea6a",
  null
  
)

export default component.exports